<template>
  <div style="background-color: #f4f5fd">
    <b-row>
      <b-col cols="12">
        <b-breadcrumb
          style="background-color:#f8f9fa"
          :items="itemsBreadcrumb"
        ></b-breadcrumb>
          <ThemeTwoDashboard />
        <!-- <div v-if="$store.state.showSidebar">
        </div>
        <div v-else>
          <NewDashboardTheme />
        </div> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ThemeTwoDashboard from "./employeeDashboard/themeTwoDashboard.vue";
import NewDashboardTheme from "./employeeDashboard/newDashboardTheme.vue";
export default {
  name: "EmployeeDashboard",
  components: {
    ThemeTwoDashboard,
    NewDashboardTheme
  },
  data () {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "#",
        },
      ],
    };
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
/* @import "../../assets/styles/theme1/card.css"; */
@import "../../assets/styles/theme1/badge.css";
</style>

<style>
.table-hover tbody tr:hover td {
  background-color: rgb(255, 251, 242) !important;
}
</style>
